import styled from "styled-components";

const StyledJourney = styled.div`
  background: #565656;
  font-size: 0.8em;
  padding: 2px 5px;
  height: 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 5px;
`;

export default StyledJourney;
